import { validate } from 'parameter-validator';
import useMutation from 'api/hooks/useMutation';
import useTrackWithUser from 'api/hooks/useTrackWithUser';
import permissions from 'api/Apollo/permissions';

import { SCHEMAS_QUERY } from 'api/schemas/schemas-query-builder';
import { GET_SCHEMA_NAMES } from 'api/schemas/schema-names-query-builder';

import {
  mutation as removeSchemaMutation,
  buildVariables as buildRemoveSchemaVariables,
} from './remove-schema-mutation-builder';

export default function useRemoveSchema(options = {}) {
  const [trackWithUser] = useTrackWithUser('schema_deleted');
  const [executeMutation, response] = useMutation(removeSchemaMutation, {
    successMsg: 'Schema removed.',
    context: { permission: permissions.deleteSchemas },
    refetchQueries: [SCHEMAS_QUERY, { query: GET_SCHEMA_NAMES }],
    ...options,
  });

  const removeSchema = args => {
    const { id, name, description } = validate(args, ['id', 'name', 'description']);
    const variables = buildVariables({ id, name, description });
    return executeMutation(variables).then(response => {
      if (!response.errors) {
        trackWithUser({ id, name, description });
      }
      return response;
    });
  };
  return [removeSchema, response];
}

function buildVariables({ id }) {
  return {
    variables: {
      ...buildRemoveSchemaVariables({ id }),
    },
  };
}
